export const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-40%',
        transform: 'translate(-50%, -50%)',
        padding: "0px",
        minWidth: "350px",
        maxWidth: "600px",
        width: "98%",
        borderRadius: "20px",
        background: "linear-gradient(180deg, rgba(255, 223, 87, 1) 0%, rgba(145, 70, 15, 1) 63.11%, rgba(58, 24, 47, 1) 82.51%, rgba(27, 25, 38, 1) 100%)",
        color: "white",
        border: "1px solid white",
        minHeight: "300px"
    },
};

export const headerContainerStyle = {
    height: "20px",
    paddingTop: "8px",
}

export const iconStyle = {
    float: "right",
    color: "white",
    marginTop: "5px",
    marginRight: "10px",
}

export const titleStyle = {
    textAlign: "center",
    fontWeight: "500",
    fontSize: "16px",
    marginBottom: "20px"
}

export const textStyle = {
    marginTop: "10px",
    textAlign: "center",
    // fontWeight: "500",
    fontSize: "12px",
}

export const headerStyle = {
    background: "linear-gradient(90deg, #35080A 0%, #8E592F 100%)",
    width: "200px",
    margin: "auto",
    borderRadius: "15px",
    color: "white",
}

export const selectStyle = {
    maxWidth: "300px",
    width: "90%",
    margin: "auto",
    color: "black"
}